export const SDK_GLOBAL = 'YT';
export const SDK_URL = 'https://www.youtube.com/iframe_api';
export const SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
export const NO_COOKIE_HOST = 'https://www.youtube-nocookie.com';
export const MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
export const MATCH_NUMERIC = /^\d+$/;
export const MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
export const MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
export const MATCH_START_STAMP = /(\d+)(h|m|s)/g;
export const MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
export const MATCH_NO_COOKIE = /youtube-nocookie\.com/;

export const MATCH_URL_YOUTUBE =
	/(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
